import { Route } from "@/model/route.model";
import studioService from "@/services/studio.interface";

class RoutersManager {

    private routers: Route[] = [];

    public async getRouters(): Promise<Route[]> {
        if ( this.routers.length == 0) {
            this.routers = await studioService.getRouters();
        }
        return this.routers;
    }

    public async getRoute(name: string): Promise<Route> {
        const routers = await this.getRouters();
        return routers.find(r => r.name == name);
    }

}
const routersManager = new RoutersManager();
export default routersManager;